import * as actionTypes from './actionTypes';
import * as api from '../api';
import { createActionObject, getAjaxFunc } from '../../helpers/common';

export const getFindRealTimeFields = (station) => dispatch => getAjaxFunc(
  actionTypes.GET_FIND_REALTIME_FIELDS_REQUEST,
  "",
  actionTypes.GET_FIND_REALTIME_FIELDS_FAILURE,
  "",
  dispatch
)(
  () => api.findRealtimeFields(station)
    .then((response) => {
      var data;
      response.text().then(function (text) {
        data = JSON.parse(text);
        switch (response.status) {
          case 200:
            dispatch(
              createActionObject(
                actionTypes.GET_FIND_REALTIME_FIELDS_SUCCESS,
                {
                  findStationFields: data.RealTimefields,
                  findDashboardWeather: data.dashboard_weatherinfo,
                  energy: data.energy,
                  inverter: data.inverter
                }
              )
            );
            break;
          case 500:
            dispatch(
              createActionObject(
                actionTypes.GET_FIND_REALTIME_FIELDS_FAILURE,
                { findStationFields: [] }
              )
            );
            break;
          default:
            dispatch(
              createActionObject(
                actionTypes.GET_FIND_REALTIME_FIELDS_FAILURE,
                { findStationFields: [] }
              )
            );
            break;
        }
      });
    })
)()

export const selectFields = selectFields => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_FIELDS,
    { selectFields }
  )
);

export const resetSelectFields = () => dispatch => dispatch(
  createActionObject(
    actionTypes.RESET_SELECT_FIELDS,
    { selectFields: [] }
  )
);

export const selectFieldsIndex = selectFieldsIndex => dispatch => dispatch(
  createActionObject(
    actionTypes.SELECT_FIELDS_INDEX,
    { selectFieldsIndex }
  )
);